// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// -------------------------------------
// Hooks
// -------------------------------------

// Stick the header when scrolling past the top
$(window).scroll(function() {
    if ($(window).scrollTop() > 0) {
        $('#shopify-section-header').addClass('is-sticky');
    } else {
        $('#shopify-section-header').removeClass('is-sticky');
    }
});
